import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { Button } from './ui/button';
import { getApiBase } from '../utils/apiBase';

const API_URL = getApiBase() + '/api';

const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';

const detectPlatform = () => {
  try {
    if (Capacitor.isNativePlatform()) {
      return Capacitor.getPlatform(); // "ios" | "android"
    }
  } catch (_) {}
  return 'web';
};

/**
 * Uygulama startup'ta /api/client-config'i çağırır.
 * - maintenance_mode=true → tam ekran bakım mesajı.
 * - client_supported=false → tam ekran "güncelleyin" sayfası, store linki ile.
 * - Aksi → children render edilir.
 */
const ClientConfigGate = ({ children }) => {
  const [state, setState] = useState({ loaded: false, blocked: false, payload: null, error: null });

  useEffect(() => {
    let cancelled = false;
    const platform = detectPlatform();
    const url = `${API_URL}/client-config?client_version=${encodeURIComponent(APP_VERSION)}&platform=${platform}`;
    axios
      .get(url, { withCredentials: true, timeout: 8000 })
      .then((r) => {
        if (cancelled) return;
        const data = r.data || {};
        const blocked = !!data.maintenance_mode || data.client_supported === false;
        setState({ loaded: true, blocked, payload: { ...data, platform }, error: null });
      })
      .catch((e) => {
        if (cancelled) return;
        // Network hatası → uygulamayı bloklama, sessiz geç (offline tolerance)
        setState({ loaded: true, blocked: false, payload: null, error: e?.message || 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!state.loaded) {
    return (
      <div className="fixed inset-0 z-[200] bg-black flex items-center justify-center">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-violet-500" />
      </div>
    );
  }

  if (state.blocked && state.payload) {
    const { payload } = state;
    const isMaintenance = !!payload.maintenance_mode;
    const storeUrl =
      payload.platform === 'ios'
        ? payload.store_urls?.ios
        : payload.platform === 'android'
        ? payload.store_urls?.android
        : null;
    return (
      <div className="fixed inset-0 z-[200] bg-background text-zinc-200 flex items-center justify-center px-6">
        <div className="max-w-sm w-full glass-effect rounded-2xl p-7 border border-white/10 text-center shadow-xl">
          <h1
            className="text-xl font-bold text-white mb-2"
            style={{ fontFamily: 'Cinzel, serif' }}
          >
            {isMaintenance ? 'Bakım yapılıyor' : 'Güncelleme gerekli'}
          </h1>
          <p className="text-sm text-zinc-400 leading-snug mb-5">
            {isMaintenance
              ? payload.maintenance_message ||
                'Kısa süreli bakım yapılıyor. Birazdan tekrar deneyin.'
              : `Bu sürüm artık desteklenmiyor. Mağaza üzerinden güncelleyip devam edin. (Min sürüm: ${
                  payload.min_client_version?.[payload.platform] || '?'
                })`}
          </p>
          {!isMaintenance && storeUrl && (
            <Button
              type="button"
              onClick={() => {
                window.open(storeUrl, '_blank');
              }}
              className="w-full h-11 btn-primary font-semibold"
            >
              Mağazada güncelle
            </Button>
          )}
          {isMaintenance && (
            <Button
              type="button"
              onClick={() => window.location.reload()}
              className="w-full h-11 btn-primary font-semibold"
            >
              Tekrar dene
            </Button>
          )}
          <p className="text-[10px] text-zinc-500 mt-4">
            Sürüm: {APP_VERSION} · {payload.platform}
          </p>
        </div>
      </div>
    );
  }

  return children || null;
};

export default ClientConfigGate;
